import React from 'react';
import View from './View';
import adaptData from './adaptData';

const Sections = ({ data, location }) => {
   return <View {...adaptData(data, location)} />;
};

export default Sections;
